import { render, staticRenderFns } from "./HistoryTable.vue?vue&type=template&id=2eee5312"
import script from "./HistoryTable.vue?vue&type=script&lang=js"
export * from "./HistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eee5312')) {
      api.createRecord('2eee5312', component.options)
    } else {
      api.reload('2eee5312', component.options)
    }
    module.hot.accept("./HistoryTable.vue?vue&type=template&id=2eee5312", function () {
      api.rerender('2eee5312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/PushMessage/Component/HistoryTable.vue"
export default component.exports